import { render, staticRenderFns } from "./SelectAreaLayout.vue?vue&type=template&id=6fd4cc0e&"
import script from "./SelectAreaLayout.vue?vue&type=script&lang=js&"
export * from "./SelectAreaLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports